import { ApiError } from '../api/client'

/**
 * What a failed request looks like.
 *
 * It says what failed and offers the retry, and it is deliberately not an empty
 * state: "no results" and "we could not ask" are different facts, and a console that
 * renders them identically teaches its users to read silence as calm.
 */
export function Failure({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : 'something went wrong'

  return (
    <div className="error" role="alert">
      <strong>This did not load.</strong>
      <p style={{ margin: 'var(--space-2) 0' }}>{message}</p>
      <p className="muted" style={{ marginTop: 0 }}>
        This is not an empty result — the request failed, so what you would have seen is
        unknown.
      </p>
      {onRetry && <button onClick={onRetry}>Try again</button>}
    </div>
  )
}
